import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatchingService } from '../Services/matching.service';
import { CustomerInputService } from '../Services/customer-input.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-matching-list',
  templateUrl: './matching-list.component.html',
  styleUrls: ['../matching/matching.component.css'],

})
export class MatchingListComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  customer_list: any;
  cl_length: number;
  place_list: any;
  lc = {
    conditions: '1',
  }

  constructor(
    private router: Router,
    public matchingService: MatchingService,
    public customerInputService: CustomerInputService,
    public auth: AuthService
  ) {
  }


  ngOnInit() {
    this.lc.conditions = this.matchingService.mltab_conditions;
    let List = this.matchingService.matchingList(this.lc.conditions);
    List.subscribe(List => {
      this.customer_list = List;
      this.cl_length = Object.keys(this.customer_list).length;
    });
    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
    });
  }

  //顧客一覧絞込用（割当）
  matchingList() {
    let List = this.matchingService.matchingList(this.lc.conditions);
    List.subscribe(List => {
      this.customer_list = List;
      this.cl_length = Object.keys(this.customer_list).length;
    });
  }

  //マッチング画面へ
  matchingScene(request_code) {
    this.matchingService.mltab_conditions = this.lc.conditions;
    this.router.navigate(['/matching/' + request_code]);
  }

  //顧客詳細画面へ
  customerDetail(customer_code) {
    this.matchingService.br_flg = true;
    this.matchingService.mltab_conditions = this.lc.conditions;
    this.router.navigate(['/detail/' + customer_code]);
  }

}

